import {connect} from "react-redux";
import type {ApplicationState} from "../../../reducers";
import P24PayPalButton from "../../../components/checkout/dataSummaryBox/P24PayPalButton";
import {notifyPayPalPaymentCancelled, notifyPayPalPaymentSuccessful, setPaymentError} from "../../../actions/order";
import {PAYMENT_METHODS} from "../../../models/PaymentRequests";

const mapStateToProps = (state: ApplicationState, _ownProps) => {
	return {
		buyerName: `${state.order.adress.name} ${state.order.adress.familyname}`,
		buyerEmail: state.order.adress.email,
        payPalPaymentRef: state.cart.paymentFacility.account.referenceId
    };
};

const mapDispatchToProps = dispatch => {
	return {
        onPaymentSuccess: (_referenceId: string) => {
            dispatch(notifyPayPalPaymentSuccessful());
        },
        onPaymentCancelled: (_referenceId: string) => {
            dispatch(notifyPayPalPaymentCancelled());
        },
        onPaymentError: () => {
            dispatch(setPaymentError(PAYMENT_METHODS.PRZELEWY24));
        }
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(P24PayPalButton);
